var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79685 10.2825V9.1425H6.00197V8.0025H7.19921V6.855H8.39645V5.715H9.60157V4.575H10.7988V3.4275H13.2012V4.575H14.3984V5.715H15.6035V6.855H16.8008V8.0025H17.998V9.1425H19.2031V10.2825H20.4004V22.86H21.6055V12.57H22.8028V11.43H24V10.2825H22.8028V9.1425H21.6055V8.0025H20.4004V6.855H19.2031V5.715H17.998V4.575H16.8008V3.4275H15.6035V2.2875H14.3984V1.14H13.2012V0H10.7988V1.14H9.60157V2.2875H8.39645V3.4275H7.19921V4.575H6.00197V5.715H4.79685V6.855H3.59961V8.0025H2.40236V9.1425H1.19724V10.2825H0V11.43H1.19724V12.57H2.40236V22.86H3.59961V10.2825H4.79685Z",
    fill: "#ff7eb6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 24V22.86H15.6035V13.7175H14.3984V22.86H9.60158V13.7175H8.39646V22.86H3.59961V24H20.4004Z",
    fill: "#ff7eb6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2031 14.8575H16.8008V17.145H19.2031V14.8575Z",
    fill: "#ff7eb6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3984 6.85498H13.2012V9.14248H14.3984V6.85498Z",
    fill: "#ff7eb6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2012 5.71503H10.7988V6.85503H13.2012V5.71503Z",
    fill: "#ff7eb6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 17.145H10.7988V18.285H12.0039V17.145Z",
    fill: "#ff7eb6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3984 12.57H9.60156V13.7175H14.3984V12.57Z",
    fill: "#ff7eb6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2012 9.14252H10.7988V10.2825H13.2012V9.14252Z",
    fill: "#ff7eb6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7988 6.85498H9.60156V9.14248H10.7988V6.85498Z",
    fill: "#ff7eb6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19924 14.8575H4.79688V17.145H7.19924V14.8575Z",
    fill: "#ff7eb6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3f47b12cdd65157c7abb1625e1f9c8fb.svg";
export { ForwardRef as ReactComponent };